<template>
	<div class="box">
		<div class="charts-header">
			<div>
				 <el-select v-model="value" placeholder="请选择" @change="getPage()">
				    <el-option
				      v-for="item in options"
				      :key="item.id"
				      :label="item.name"
				      :value="item.id">
				    </el-option>
				  </el-select>
			</div>
			<div class="fr" @click="exportExcel">导出数据</div>
		</div>
		<div>
			<div v-show="value==1" ref="echarts1" class="echart">
  			</div>
  			<div v-show="value==2"  ref="echarts2" class="echart">
  			</div>
  			<div v-show="value==3"  ref="echarts3" class="echart">
  			</div>
  			<div v-show="value==4"  ref="echarts4" class="echart">
  			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default{
		props: ['type','options','datafb','datazc','datazs','datafb1','dates'],
		data(){
			return{
				value:1,
				chart1: null,
				chart2: null,
				chart3: null,
				chart4: null,
				chartsB:false,
				optionselect:this.options,
//				types:this.type,
		        option: this.datazc,
		        option2:this.datafb,
		        option1:this.datazs,
		        dates:this.dates
			}
		},
		 mounted() {
		 	this.value=this.type;
	      	this.getPage();
	    },
	    watch:{
	    	datafb:{
	    		handler(val,oldVal){
	    			this.getPage();
	    		},
	    		deep: true 
	    	},
	    	datazc:{
	    		handler(val,oldVal){
	    			this.getPage();
	    		},
	    		deep: true 
	    	},
	    	datazs:{
	    		handler(val,oldVal){
	    			this.getPage();
	    		},
	    		deep: true 
	    	},
	    },
		methods: {
			exportExcel() {
				var arr=[]
				if(this.value==1){
					for(var i=0;i<this.option1.xAxis.data.length;i++){
						var json={
							index:i,
							date:this.option1.xAxis.data[i],
							num:this.option1.series[0].data[i]
						}
						arr.push(json)
					}
				}else if(this.value==2){
					for(var i=0;i<this.option.xAxis.data.length;i++){
						var json={
							index:i,
							date:this.option.xAxis.data[i],
							num:this.option.series[0].data[i]
						}
						arr.push(json)
					}
				}else if(this.value==3){
					for(var i=0;i<this.option2.xAxis.data.length;i++){
						var json={
							index:i,
							date:this.option2.xAxis.data[i],
							num:this.option2.series[0].data[i]
						}
						arr.push(json)
					}
				}

				 require.ensure([], () => {
				    const { export_json_to_excel } = require('../Excel/Export2Excel');//注意这个Export2Excel路径
				    const tHeader = ['日期', this.optionselect[this.value-1].name];   // 上面设置Excel的表格第一行的标题
				    const filterVal = ['date', 'num']; // 上面的index、nickName、name是tableData里对象的属性key值
				    const list = arr;  //把要导出的数据tableData存到list
				    const data = this.formatJson(filterVal, list);
				    export_json_to_excel(tHeader, data, this.optionselect[this.value-1].name+'_'+this.gshFn(this.dates));//最后一个是表名字
				  })
			 	this.$message({
					message: '已导出',
					type: 'success',
					duration: 1000,
					onClose: () => {
					}
				})
			},
			formatJson(filterVal, jsonData) {
			  return jsonData.map(v => filterVal.map(j => v[j]))
			},
			gshFn(str){
				if(str.length==0){
					
				}else{
					var a=str[0].split('-');
					var b=str[1].split('-');
					return a[0]+a[1]+a[2]+'-'+b[0]+b[1]+b[2];
				}
			},
		    getPage() {
		    	this.chart1=null;
		    	this.chart2=null;
		    	this.chart3=null;
		    	this.chart4=null;

		        // 使用刚指定的配置项和数据显示图表。
		        if(this.value==1){
		    		this.chart1 = echarts.init(this.$refs.echarts1);
		        	this.chart1.setOption(this.datazs);
		        }else if(this.value==2){
		        	this.$nextTick(()=>{
			    		this.chart2 = echarts.init(this.$refs.echarts2);
			        	this.chart2.setOption(this.datazc);
		        	})
		        }else if(this.value==3){
		        	this.$nextTick(()=>{
			    		this.chart3 = echarts.init(this.$refs.echarts3);
			        	this.chart3.setOption(this.datafb);
		        	})
		        }else if(this.value==4){
		        	this.$nextTick(()=>{
			    		this.chart4 = echarts.init(this.$refs.echarts4);
			        	this.chart4.setOption(this.datafb1);
		        	})
		        }
		      }
		    }
	}
</script>

<style scoped>
	.charts-header{
		display: flex;
		align-items: center;
	}
	.charts-header>div:nth-child(1){
		margin: 0 auto;
	}
	.charts-header>div.fr{
		height:30px;
		width:70px;
		background:rgba(29,181,255,1);
		border-radius: 4px;
		font-size:15px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:#FFFFff;
		margin-right: 60px;
		border: 1px solid transparent;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}
	.charts-header>div.fr:hover{
		border: 1px solid yellow;
	}
	.echart{
		width: 490px;
		height: 280px;
	}
</style>


// WEBPACK FOOTER //
// src/component/charts.vue